import React from 'react';
import { motion } from 'framer-motion';
import { Users, Clock, Heart, Activity } from 'lucide-react';

export function ClientRetentionMetrics() {
  const metrics = [
    {
      label: 'Client Retention',
      value: '92%',
      change: '+2%',
      description: 'Monthly retention rate',
      icon: <Users className="w-4 h-4" />
    },
    {
      label: 'Avg. Client Age',
      value: '8.5',
      unit: 'months',
      change: '+1.2',
      description: 'Average client relationship duration',
      icon: <Clock className="w-4 h-4" />
    },
    {
      label: 'Client Satisfaction',
      value: '4.8',
      unit: '/5',
      change: '+0.2',
      description: 'Average satisfaction rating',
      icon: <Heart className="w-4 h-4" />
    },
    {
      label: 'Goal Achievement',
      value: '85%',
      change: '+5%',
      description: 'Client goal completion rate',
      icon: <Activity className="w-4 h-4" />
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric, index) => (
        <motion.div
          key={metric.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              {metric.icon}
              <span>{metric.label}</span>
            </div>
            <div className="text-2xl font-bold">
              {metric.value}
              {metric.unit && <span className="text-base ml-1">{metric.unit}</span>}
            </div>
            <div className="flex items-center gap-1 text-xs text-success mt-1">
              <span>{metric.change}</span>
              <span className="text-muted-foreground">{metric.description}</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}